<template>
	<div>
		<SOSlotBase :bg-white="true" :loading="pageSetting.loading">
			<template v-slot:loading-page>
				<SOLoadingPage/>
			</template>

			<template v-slot:title-bar>
				<SOTitleBar
					:page-title="'Penyesuaian Paket E-payment'"
					:type="'back'"
					@back="back"
				/>
			</template>

			<template v-slot:content>
				<div class="flex-100">
					<div class="flex-1">
						<div class="p-x-20 p-y-12 f-regular f-14 f-c-black">
							Jenis paket diubah, sehingga Anda perlu mengatur masa aktif paket E-Payment yang ada.
						</div>
						<div class="separator"></div>
						<div class="p-x-20 p-y-20 border-bottom">
							<div class="custom-control custom-radio remove-padding-lr m-t-8">
								<input class="custom-control-input"
								       v-model="selectedOption"
								       type="radio"
								       id="ppe-1"
								       name="ppe"
								       value="1"
								/>
								<label class="custom-control-label" for="ppe-1">
									Atur semua paket sekaligus
								</label>
							</div>

							<div class="p-x-20 p-t-20 w-75" v-if="selectedOption === '1'">
								<SOInputNominal
									:title="`Masa aktif ${dataPaketEmoney.length} paket dari ${dataPaketEmoneyPerOutlet.length} outlet:`"
									:default-value="dataPaketEmoneyAll.formatted"
									:placeholder="'1'"
									:prefix-right="true"
									:prefix="'Hari'"
									v-model="dataPaketEmoneyAll"
									@input="(val) => { dataPaketEmoneyAll = val }"
								/>
							</div>
						</div>
						<div class="p-x-20 p-y-20 border-bottom">
							<div class="custom-control custom-radio remove-padding-lr m-t-8">
								<input class="custom-control-input"
								       v-model="selectedOption"
								       type="radio"
								       id="ppe-2"
								       name="ppe"
								       value="2"
								/>
								<label class="custom-control-label" for="ppe-2">
									Atur per outlet
								</label>
							</div>

							<div class="p-t-20" v-if="selectedOption === '2'">
								<div class="form-epayment-peroutlet m-d-16"
								     v-for="(data, i) in penyesuaian.data" :key="i">
									<div class="form-epayment-peroutlet-header">
										<div class="f-regular f-16 f-c-black">{{ data.nama_outlet }}</div>
										<div class="d-flex-between-center">
											<div class="f-regular f-14 f-c-midgrey">
												Masa aktif semua <b>{{ data.data_paket_emoney.length }}</b> paket:
											</div>
											<div class="d-flex align-items-center">
												<input
													placeholder="--"
													type="tel"
													class="form-control number-only"
													style="width: 64px"
													v-model="dataPaketEmoneyPerOutlet[dataPaketEmoneyPerOutlet.findIndex(v => v.idoutlet === data.idoutlet)].expired"
												>
												<div class="f-regular f-14 f-c-midgrey m-l-8">Hari</div>
											</div>
										</div>
									</div>
									<div class="form-epayment-peroutlet-body">
										<div class="p-x-20 p-y-12 d-flex" @click="collapse(data.idoutlet)">
											<div class="f-regular f-13 f-c-blue m-r-4">
												Atur manual satu-persatu
											</div>
											<img src="@/assets/icons/chevron-rotate-down.svg"
											     :id="'chev-' + data.idoutlet"
											     alt="">
										</div>
										<div class="border-top" :id="data.idoutlet" style="display: none">
											<div class="d-flex-between-center p-x-20 p-y-8 border-bottom"
											     v-for="epayment in data.data_paket_emoney">
												<div class="f-regular f-14 f-c-black">
													{{ epayment.nama_paket_emoney }}
												</div>
												<div class="d-flex align-items-center">
													<input
														type="tel"
														class="form-control number-only"
														style="width: 64px"
														v-model="dataPaketEmoney[dataPaketEmoney.findIndex(v => v.idpaketemoney === epayment.idemoney)].masa_aktif"
														@keyup="clearExpiredPerOutlet(data.idoutlet)"
													>
													<div class="f-regular f-14 f-c-midgrey m-l-8">Hari</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="p-x-20 p-d-72">
						<SOButton
							:text="'Simpan'"
							:disable="selectedOption === ''"
							:primary="true"
							:full="true"
							:loading="pageSetting.btn.update.loading"
							@action="showModal"
						/>
					</div>
				</div>
			</template>

			<template v-slot:modal>
				<SOSlotModal
					:modal-title="'Simpan Perubahan'"
					:modal-id="'modal-simpan-perubahan'"
					@close="closeModal">
					<template v-slot:modal-body>
						<div class="f-regular f-16 f-c-black">
							Yakin ingin menyimpan perubahan?
						</div>
					</template>
					<template v-slot:modal-footer>
						<SOButton
							:outline="true"
							:full="true"
							:loading="pageSetting.btn.confirmUpdate.loading"
							:disable="pageSetting.btn.confirmUpdate.disable"
							:text="'Ya, Simpan'"
							@action="update"
						/>
					</template>
				</SOSlotModal>
			</template>
		</SOSlotBase>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRadio from "@/so-components/global/input/SOInputRadio";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
	name: "PenyesuaianPaketEpayment",
	components: {
		SOSlotBase,
		SOLoadingPage,
		SOTitleBar,
		SOInputRadio,
		SOButton,
		SOInputNominal,
		SOSlotModal,
	},
	computed: {
		...mapGetters("pengaturanUmumModule", {
			penyesuaian: "penyesuaian"
		})
	},
	data() {
		return {
			pageSetting: {
				loading: false,
				btn: {
					update: {
						loading: false,
						disable: false,
					},
					confirmUpdate: {
						loading: false,
						disable: false,
					}
				}
			},
			selectedOption: "",

			dataPaketEmoney: [],
			dataPaketEmoneyDefault: [],
			dataPaketEmoneyPerOutlet: [],
			dataPaketEmoneyAll: {
				formatted: "",
				raw: 0,
			},
			dataOnLoad: false,
			ignoreReset: false,

			// query
			idOutlet: "",
			epaymentRouteType: "",
			id: "",
		}
	},
	mounted() {
		this.getListPenyesuaian()

		this.idOutlet = this.$route.query.idOutlet
		this.epaymentRouteType = this.$route.query.epaymentRouteType
		this.id = this.$route.query.id
	},
	watch: {
		selectedOption: {
			handler: function () {
				this.regexNumberOnly()
				this.dataPaketEmoney = JSON.parse(JSON.stringify(this.dataPaketEmoneyDefault))
			},
			deep: true,
		},
		dataPaketEmoneyPerOutlet: {
			handler: function (val) {
				if (!this.dataOnLoad) this.expiredPerOutlet(val)

				this.dataPaketEmoneyPerOutlet.forEach(v => {
					v.expired = parseInt(v.expired) === 0 || v.expired === "" ? "" : parseInt(v.expired)
				})
			},
			deep: true,
		},
		dataPaketEmoneyAll: {
			handler: function (val) {
				if (!this.dataOnLoad) this.expiredAll(val)
			},
			deep: true,
		},
		dataPaketEmoney: {
			handler: function () {
				this.dataPaketEmoney.forEach(v => {
					v.masa_aktif = parseInt(v.masa_aktif) === 0 ? 1 : parseInt(v.masa_aktif)
				})
			},
			deep: true,
		}
	},
	methods: {
		back() {
			this.$router.back()
		},
		async getListPenyesuaian() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("pengaturanUmumModule/listPenyesuaian")
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
			}

			this.dataOnLoad = true
			this.penyesuaian.data.forEach(v => {
				this.dataPaketEmoneyPerOutlet = [
					...this.dataPaketEmoneyPerOutlet,
					{
						idoutlet: v.idoutlet,
						expired: "",
						idemoney: [],
					}
				]

				let expiredOutlet = ""
				let isSameExpiredExport = true
				v.data_paket_emoney.forEach((vv, i) => {
					this.dataPaketEmoney = [
						...this.dataPaketEmoney,
						{
							idpaketemoney: vv.idemoney,
							masa_aktif: vv.masa_aktif_days,
						}
					]

					let dataPaketEmonetPerOutletIndex = this.dataPaketEmoneyPerOutlet.findIndex(i => i.idoutlet === v.idoutlet)
					this.dataPaketEmoneyPerOutlet[dataPaketEmonetPerOutletIndex].idemoney = [
						...this.dataPaketEmoneyPerOutlet[dataPaketEmonetPerOutletIndex].idemoney,
						vv.idemoney
					]

					if (isSameExpiredExport) {
						if (i === 0) {
							expiredOutlet = vv.masa_aktif_days
							this.dataPaketEmoneyPerOutlet[dataPaketEmonetPerOutletIndex].expired = vv.masa_aktif_days
						} else {
							if (expiredOutlet === vv.masa_aktif_days) {
								this.dataPaketEmoneyPerOutlet[dataPaketEmonetPerOutletIndex].expired = vv.masa_aktif_days
							} else {
								isSameExpiredExport = false
								this.dataPaketEmoneyPerOutlet[dataPaketEmonetPerOutletIndex].expired = ""
							}
						}
					}
				})
			})

			this.selectedOption = this.cekJenisPenyesuaian() ? '1' : '2'
			if (this.selectedOption) this.dataPaketEmoneyAll.formatted = this.dataPaketEmoney[0].masa_aktif.toString()
			this.dataPaketEmoneyDefault = JSON.parse(JSON.stringify(this.dataPaketEmoney))

			setTimeout(() => {
				this.dataOnLoad = false
			}, 1000)
		},
		cekJenisPenyesuaian() {
			let expired = 0
			for (let i = 0; i < this.dataPaketEmoney.length; i++) {
				if (i === 0) {
					expired = this.dataPaketEmoney[i].masa_aktif
					continue
				}
				if (expired !== this.dataPaketEmoney[i].masa_aktif) {
					return false
				}
			}
			return true
		},
		expiredPerOutlet(val) {
			val.forEach(v => {
				if (v.expired !== "") {
					v.idemoney.forEach(idemoney => {
						let index = this.dataPaketEmoney.findIndex(i => i.idpaketemoney === idemoney)
						this.dataPaketEmoney[index].masa_aktif = v.expired
					})
				} else { // back to default value
					if (!this.ignoreReset) {
						v.idemoney.forEach(idemoney => {
							let index = this.dataPaketEmoney.findIndex(i => i.idpaketemoney === idemoney)
							this.dataPaketEmoney[index].masa_aktif = this.dataPaketEmoneyDefault[index].masa_aktif
						})
					}
					this.ignoreReset = false
				}
			})
		},
		clearExpiredPerOutlet(idoutlet) {
			let index = this.dataPaketEmoneyPerOutlet.findIndex(i => i.idoutlet === idoutlet)
			this.ignoreReset = true
			this.dataPaketEmoneyPerOutlet[index].expired = ""
		},
		expiredAll(val) {
			this.dataPaketEmoney.forEach(v => {
				v.masa_aktif = val.raw.toString()
			})
		},
		async update() {
			this.pageSetting.btn.confirmUpdate.disable = true
			this.pageSetting.btn.confirmUpdate.loading = true

			// force to number
			this.dataPaketEmoney.forEach(v => {
				v.masa_aktif = parseInt(v.masa_aktif)
			})

			// update
			const res = await this.$store.dispatch("pengaturanUmumModule/updateMasaAktifEpaymentLimited", {
				"data_paket_emoney": this.dataPaketEmoney
			})

			this.pageSetting.btn.confirmUpdate.disable = false
			this.pageSetting.btn.confirmUpdate.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.$toast.success(res.msg)
			this.closeModal()
			if (this.idOutlet === undefined) {
				this.$router.push({name: "pengaturanUmum.dashboard"})
			} else {
				this.$router.push(`/addOutlet/${this.idOutlet}/emoney/${this.epaymentRouteType}/${this.id}`);
			}
		},
		showModal() {
			$("#modal-simpan-perubahan").modal("show")
		},
		closeModal() {
			$("#modal-simpan-perubahan").modal("hide")
		},

		regexNumberOnly() {
			setTimeout(() => {
				$(".number-only").keyup(function () {
					$(".number-only").each(function () {
						let val = $(this).val()
						if (val.substr(0) === "0") {
							val = val.substr(1)
						}
						let afterRegex = val.replace(/[^0-9]+/g, "")
						$(this).val(afterRegex)
					})
				})
			}, 100)
		},
		collapse(id) {
			$("#" + id).slideToggle()
			if ($("#chev-" + id).hasClass("chev-rotate-180")) {
				$("#chev-" + id).removeClass("chev-rotate-180")
			} else {
				$("#chev-" + id).addClass("chev-rotate-180")
			}
		}
	}
}

</script>

<style scoped>
.form-epayment-peroutlet {
	border: 1px solid #C8D0DD;
	border-radius: 4px;
}

.form-epayment-peroutlet-header {
	background: #F6F6F6;
	padding: 10px 16px;
}

.chev-rotate-180 {
	transform: rotate(180deg);
}

::placeholder { /* Firefox, Chrome, Opera */
	color: #6F7287 !important;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
	color: #6F7287 !important;
}

::-ms-input-placeholder { /* Microsoft Edge */
	color: #6F7287 !important;
}

.number-only {
	text-align: center;
}
</style>